import React from 'react';
import PropTypes from 'prop-types';

const hotKeys = ['Escape', 'Enter'];

class NavBarExtras extends React.Component {
  state = {
    displayExtras: false,
  }

  onToggleExtras = (evt) => {
    if (!evt.key || hotKeys.includes(evt.key)) {
      this.setState(({ displayExtras }) => ({ displayExtras: !displayExtras }));
    }
  }

  render() {
    return (
      <div className="dropdown d-inline-block m-2 btn btn-outline-secondary btn-sm" id="navbar-extras-toggle" onClick={this.onToggleExtras} onKeyDown={this.onToggleExtras} role="button" tabIndex="0">
        <span>&bull;&bull;&bull;</span>
        {this.state.displayExtras ? (
          <div className="dropdown-menu show">
            <button type="button" className="dropdown-item" id="clone-form-btn" onClick={() => this.props.onCloneForm({ shouldMakeExperimental: false })} disabled={this.props.shouldSuppressPublish}>Clone Form</button>
            <button type="button" className="dropdown-item" id="experimental-clone-form-btn" onClick={() => this.props.onCloneForm({ shouldMakeExperimental: true })} disabled={this.props.shouldSuppressPublish}>Clone Experimental Form</button>
            <button type="button" className="dropdown-item" id="publish-form-btn" onClick={this.props.onPublishForm} disabled={this.props.shouldSuppressPublish}>Publish Form</button>
            <button type="button" className="dropdown-item" id="unpublish-form-btn" onClick={this.props.onUnpublishForm} disabled={!this.props.isPublished}>Unpublish Form</button>
          </div>
        ) : null}

      </div>
    );
  }

}

NavBarExtras.propTypes = {
  isPublished: PropTypes.bool.isRequired,
  onCloneForm: PropTypes.func.isRequired,
  onPublishForm: PropTypes.func.isRequired,
  onUnpublishForm: PropTypes.func.isRequired,
  shouldSuppressPublish: PropTypes.bool.isRequired,

};

export default NavBarExtras;
